module.exports = __webpack_public_path__ + "img/recommendation-3.b8876ee5.svg";